import { DesignSystemMembershipUpdates } from "@supernova-studio/model";
import { z } from "zod";
import { DTODesignSystemRole } from "./role";

//
// Read
//

export const DTODesignSystemMember = z.object({
  userId: z.string(),

  /**
   * Role that the member has in the design system,
   * undefined if set to inherit from workspace
   */
  designSystemRole: DTODesignSystemRole.optional(),
});

export const DTODesignSystemInvitation = z.object({
  id: z.string(),
  workspaceInvitationId: z.string(),

  /**
   * Role that the invitation has in the design system,
   * undefined if set to inherit from workspace
   */
  designSystemRole: DTODesignSystemRole.optional(),
});

export const DTODesignSystemMemberListResponse = z.object({
  members: DTODesignSystemMember.array(),
  invitations: DTODesignSystemInvitation.array(),
});

export const DTODesignSystemMembersUpdateResponse = z.object({
  ok: z.literal(true),
});

export type DTODesignSystemMember = z.infer<typeof DTODesignSystemMember>;
export type DTODesignSystemInvitation = z.infer<typeof DTODesignSystemInvitation>;
export type DTODesignSystemMemberListResponse = z.infer<typeof DTODesignSystemMemberListResponse>;
export type DTODesignSystemMembersUpdateResponse = z.infer<typeof DTODesignSystemMembersUpdateResponse>;

//
// Write
//

export const DTODesignSystemMembersUpdatePayload = DesignSystemMembershipUpdates;

export type DTODesignSystemMembersUpdatePayload = z.infer<typeof DTODesignSystemMembersUpdatePayload>;
